module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "teams-standard@4x.8248b146.png" + "?" + Date.now();